import React, { useState, createContext, ReactElement } from 'react';

interface MergeDuplicateMetricsContextType {
  // The metric that will be used to replace the duplicates.
  primaryMetric: Metrics.NormalMetric | undefined;
  setPrimaryMetric: React.Dispatch<
    React.SetStateAction<Metrics.NormalMetric | undefined>
  >;
  duplicateMetrics: Metrics.NormalMetric[];
  setDuplicateMetrics: React.Dispatch<
    React.SetStateAction<Metrics.NormalMetric[]>
  >;
  hasDatasets: boolean;
  setHasDatasets: React.Dispatch<React.SetStateAction<boolean>>;
}

const MergeDuplicateMetricsContext =
  createContext<MergeDuplicateMetricsContextType>({
    primaryMetric: undefined,
    setPrimaryMetric: () => null,
    duplicateMetrics: [],
    setDuplicateMetrics: () => null,
    hasDatasets: false,
    setHasDatasets: () => null,
  });

const MergeDuplicateMetricsProvider = ({
  children,
}: {
  children: ReactElement;
}) => {
  const [primaryMetric, setPrimaryMetric] = useState<
    Metrics.NormalMetric | undefined
  >(undefined);
  const [duplicateMetrics, setDuplicateMetrics] = useState<
    Metrics.NormalMetric[]
  >([]);
  const [hasDatasets, setHasDatasets] = useState(false);

  return (
    <MergeDuplicateMetricsContext.Provider
      value={{
        setPrimaryMetric,
        primaryMetric,
        duplicateMetrics,
        setDuplicateMetrics,
        hasDatasets,
        setHasDatasets,
      }}
    >
      {children}
    </MergeDuplicateMetricsContext.Provider>
  );
};

export { MergeDuplicateMetricsContext, MergeDuplicateMetricsProvider };
